import { IconButton, Badge, Button } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';
import useStyles from '../styles';
import { requiredLogin } from '../../../../middlewares';
import { useHistory } from 'react-router';
import NavigationConfig from 'navigation/config';
import { ChatNotifications } from 'components/compounds/Chat';

const ConversationButton = () => {
  const classes = useStyles({});
  const history = useHistory();
  const handleClick = () => {
    history.push(NavigationConfig.chatPage({ chatGuid: '' }).path);
  };

  return (
    <Button
      color="inherit"
      // className={clsx(classes.navbarElementSpacing)}
      onClick={handleClick}
    >
      <ChatNotifications />
    </Button>
  );
};

export default requiredLogin(ConversationButton);
